import { useEffect, useRef } from 'react';
import { ContractInfo } from 'api/types/httpsTypes/contracts';

const PRICE_CHART_ID = 'price-chart-widget-container';

type Props = {
  contract: ContractInfo;
  chartHeight?: number;
};

declare global {
  interface Window {
    createMyWidget?: (
      containerId: string,
      options: Record<string, any>
    ) => void;
  }
}
export const MoraliChartWidget = ({ contract, chartHeight: h }: Props) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const loadWidget = () => {
      if (typeof window.createMyWidget === 'function') {
        window.createMyWidget(PRICE_CHART_ID, {
          autoSize: true,
          chainId: 'solana',
          pairAddress: contract.liquidityInfo.activePools[0].poolAddress,
          defaultInterval: '1D',
          timeZone:
            Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'Etc/UTC',
          theme: 'moralis',
          locale: 'en',
          backgroundColor: 'rgba(18, 18, 18, 1)',
          gridColor: 'rgba(34, 36, 39, 1)',
          textColor: 'rgba(245, 245, 245, 1)',
          candleUpColor: 'rgba(136, 214, 147, 0.68)',
          candleDownColor: 'rgba(240, 72, 102, 0.68)',
          hideLeftToolbar: false,
          hideTopToolbar: false,
          hideBottomToolbar: false,
        });
      } else {
        console.error('An error occurred when loading the chart.');
      }
    };

    if (!document.getElementById('moralis-chart-widget')) {
      const script = document.createElement('script');
      script.id = 'moralis-chart-widget';
      script.src = 'https://moralis.com/static/embed/chart.js';
      script.type = 'text/javascript';
      script.async = true;
      script.onload = loadWidget;
      script.onerror = () => {
        console.error('An error occurred when loading the chart.');
      };
      document.body.appendChild(script);
    } else {
      loadWidget();
    }
  }, []);

  return (
    <div style={{ width: '100%', height: h }}>
      <div
        id={PRICE_CHART_ID}
        ref={containerRef}
        style={{ width: '100%', height: h }}
      />
    </div>
  );
};
